import type { HostKind } from '#util/host.ts';
import type { HostFormData } from '../host-form-schema.ts';

export const makeDefaultValues = (kind: HostKind): Omit<HostFormData, 'configOverrides'> => ({
  name: '',
  publicIPOrHostname: '',
  // 0 lets the api pick a port, which only suits hosts — lighthouses and relays have to be dialable
  // at a known one.
  listenPort: kind === 'host' ? 0 : 4242,
  roleID: '',
  roleName: '',
  networkID: '',
  ipv4Address: '',
  ipv6Address: '',
  ipv4Enabled: true,
  tags: [],
});
